import { PayloadAction } from '@reduxjs/toolkit';

import { isNotDefaultTab, isPluginTab, SidebarState, TabInfo } from 'editor/src/store/editorModules/sidebar/types';

function findTabIndex(tabToFind: TabInfo, tabs: TabInfo[]) {
  const customTab = isNotDefaultTab(tabToFind);
  const pluginTab = isPluginTab(tabToFind);
  return tabs.findIndex((tab) => {
    if (isNotDefaultTab(tab)) {
      return customTab && tab.id === tabToFind.id;
    }

    if (isPluginTab(tab)) {
      return pluginTab && tab.id === tabToFind.id;
    }

    return tab === tabToFind;
  });
}

const updateSidebarTabsReducer = (
  state: SidebarState,
  action: PayloadAction<{ tabs: TabInfo[]; isMobile: boolean; keepActiveTab?: boolean }>,
) => {
  // consider sanitizing the iconSVG entry
  const previousActiveTab = state.tabs[state.activeTabIndex];
  const { tabs, isMobile } = action.payload;

  const wasTabsLengthChanged = state.tabs.length !== tabs.length;
  const keepActiveTab = (action.payload.keepActiveTab || !wasTabsLengthChanged) && state.activeTabIndex !== -1;

  state.activeTabIndex = keepActiveTab ? findTabIndex(previousActiveTab, tabs) : -1;
  const hasTabs = state.baseTabs.length || state.pluginTabs.length;
  // A tab the editor added that the host does not list can land before the host's tabs: it is neither the one to
  // open nor the one deselecting an element goes back to.
  const isAddedByEditor = (tab: TabInfo) =>
    state.dynamicTabs.some((dynamicTab) => dynamicTab.tab === tab) && findTabIndex(tab, state.baseTabs) === -1;
  const firstHostTabIndex = tabs.findIndex((tab) => !isAddedByEditor(tab));
  const defaultTabIndex = Math.max(0, firstHostTabIndex);
  state.lastNonSystemTabIndex = !isMobile && hasTabs ? defaultTabIndex : -1;
  if (state.activeTabIndex === -1 && !isMobile && hasTabs) {
    state.activeTabIndex = defaultTabIndex;
  }
  state.tabs = tabs;
};

export default updateSidebarTabsReducer;
